import { packages } from "@shared/api/services"
import { useQuery } from "@tanstack/react-query"

export const useActivePacks = (options = {}) => {
	return useQuery({
		queryKey: ['active-packs'],
		queryFn: () => packages.getActivePacks(),
		select: data => data.data,
		...options
	})
}
